module.exports = __webpack_public_path__ + "resources/img/img_edb_2_m.97785920ea41063dfb1a83214fd85821.png";